import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheSterlingStandard from "./sections/TheSterlingStandard";
import AreasOfMastery from "./sections/AreasOfMastery";
import AdvocacyInAction from "./sections/AdvocacyInAction";
import ClientPerspectives from "./sections/ClientPerspectives";
import RequestAPrivateConsultation from "./sections/RequestAPrivateConsultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheSterlingStandard />
      <AreasOfMastery />
      <AdvocacyInAction />
      <ClientPerspectives />
      <RequestAPrivateConsultation />
      <Footer />
    </div>;
}